import { isUserSuperAdmin } from 'helpers/user';
import { lazy } from 'react';

const isSuperAdmin = isUserSuperAdmin();

const PagesRoutes = [
  {
    path: '/agents',
    component: lazy(() => import('../../pages/agents')),
    exact: true,
  },
  {
    path: '/agents/create',
    component: lazy(() => import('../../pages/agents/create')),
    exact: true,
  },
  {
    path: '/agents/:agentId/settings',
    component: lazy(() => import('../../pages/agents/edit')),
    exact: true,
  },
  {
    path: '/agents/:agentId/flows',
    component: lazy(() => import('../../pages/agents/flows')),
    exact: true,
  },
  {
    path: '/agents/:agentId/flows/create',
    component: lazy(() => import('../../pages/agents/flows/create')),
    exact: true,
  },
  {
    path: '/agents/:agentId/flows/:flowId',
    component: lazy(() => import('../../pages/agents/flows/edit')),
    exact: true,
  },

  {
    path: '/customers',
    component: lazy(() => import('../../pages/customers')),
    exact: true,
  },
  {
    path: '/customers/custom-fields',
    component: lazy(() => import('../../pages/customers/customFields')),
    exact: true,
  },
  {
    path: '/customers/create',
    component: lazy(() => import('../../pages/customers/create')),
    exact: true,
  },
  {
    path: '/customers/:customerId',
    component: lazy(() => import('../../pages/customers/edit')),
    exact: true,
  },

  {
    path: '/admins',
    component: lazy(() => import('../../pages/admins')),
    exact: true,
    hide: !isSuperAdmin,
  },
  {
    path: '/call-logs',
    component: lazy(() => import('../../pages/callLogs')),
    exact: true,
    hide: !isSuperAdmin,
  },
  {
    path: '/call-logs/:callUuid',
    component: lazy(() => import('../../pages/callLogs/view')),
    exact: true,
    hide: !isSuperAdmin,
  },

  {
    path: '/sms-logs',
    component: lazy(() => import('../../pages/smsLogs')),
    exact: true,
    hide: !isSuperAdmin,
  },

  {
    path: '/agents-statistics',
    component: lazy(() => import('../../pages/agentsStats')),
    exact: true,
  },

  {
    path: '/integrations',
    component: lazy(() => import('../../pages/integrations')),
    exact: true,
  },
  {
    path: '/integrations/create',
    component: lazy(() => import('../../pages/integrations/create')),
    exact: true,
  },
  {
    path: '/integrations/:uuid',
    component: lazy(() => import('../../pages/integrations/edit')),
    exact: true,
  },
  {
    path: '/subscription-plans',
    component: lazy(() => import('../../pages/subscriptionPlans')),
    exact: true,
  },
  {
    path: '/system-logs',
    component: lazy(() => import('../../pages/systemLogs')),
    exact: true,
    hide: !isSuperAdmin,
  },

  {
    path: '/tools',
    component: lazy(() => import('../../pages/tools')),
    exact: true,
    hide: !isSuperAdmin,
  },

  {
    path: '/services',
    component: lazy(() => import('../../pages/services')),
    exact: true,
  },
  {
    path: '/services/create',
    component: lazy(() => import('../../pages/services/create')),
    exact: true,
  },
  {
    path: '/services/:serviceId',
    component: lazy(() => import('../../pages/services/edit')),
    exact: true,
  },

  {
    path: '/route-sets',
    component: lazy(() => import('../../pages/routeSets')),
    exact: true,
    hide: !isSuperAdmin,
  },
  {
    path: '/route-sets/:routeSetId',
    component: lazy(() => import('../../pages/routeSets')),
    exact: true,
    hide: !isSuperAdmin,
  },
];

export default PagesRoutes;
